/* ==================================================
   LILLBUD – ONE CART CONTROLLER (FINAL / FROZEN)
   ================================================== */
(function () {
  'use strict';

  /* ==================================================
     Inject required CSS (ONCE)
  ================================================== */
  if (!document.getElementById('one-cart-style')) {
    const style = document.createElement('style');
    style.id = 'one-cart-style';
    style.innerHTML = `
      .lillbud_add_btn.is-loading {
        opacity: 0.85;
        pointer-events: none;
      }

      .lillbud_add_btn .btn-spinner {
        width: 14px;
        height: 14px;
        border: 2px solid rgba(255,255,255,0.4);
        border-top-color: #fff;
        border-radius: 50%;
        display: inline-block;
        margin-right: 8px;
        vertical-align: middle;
        animation: oneCartSpin 0.6s linear infinite;
      }

      @keyframes oneCartSpin {
        to { transform: rotate(360deg); }
      }

      // .lillbud_add_btn.sold-out {
      //   opacity: 0.6;
      //   cursor: not-allowed;
      // }

      /* SOLD OUT layout (video cards) */
      .product-card-actions.sold-out {
        justify-content: center;
      }
      .product-card-actions.sold-out .cart-icon-btn {
        display: none;
      }
      .product-card-actions.sold-out .video-add-btn {
        width: 80%;
      }
    `;
    document.head.appendChild(style);
  }

  /* ==================================================
     SOLD OUT UI SYNC
  ================================================== */
  // function syncSoldOutUI(btn) {
  //   if (!btn) return;

  //   const available = btn.dataset.available === 'true';
  //   const actionWrap = btn.closest('.product-card-actions');

  //   // if (!available) {
  //   //   btn.textContent = 'SOLD OUT';
  //   //   btn.disabled = true;
  //   //   btn.classList.add('sold-out');

  //   //   if (actionWrap) {
  //   //     actionWrap.classList.add('sold-out');
  //   //   }
  //   // }
  //   if (!available) {
  //     btn.textContent = 'NOTIFY ME';
  //     btn.disabled = false; // 🔥 IMPORTANT: clickable
  //     btn.classList.add('sold-out', 'notify-me');
  //     btn.dataset.cartAction = 'notify';

  //     if (actionWrap) {
  //       actionWrap.classList.add('sold-out');
  //     }
  //   }
  //     else {
  //     if (btn.dataset.cartAction === 'add' || !btn.dataset.cartAction) {
  //       btn.textContent = 'ADD TO CART';
  //     }

  //     btn.disabled = false;
  //     btn.classList.remove('sold-out');

  //     if (actionWrap) {
  //       actionWrap.classList.remove('sold-out');
  //     }
  //   }
  // }

  function syncSoldOutUI(btn) {
  if (!btn) return;

  const available = btn.dataset.available === 'true';
  const actionWrap = btn.closest('.product-card-actions');

  if (!available) {
    btn.textContent = 'NOTIFY ME';
    btn.disabled = false;

    btn.classList.add('sold-out', 'notify-me');

    // ✅ SET notify
    btn.setAttribute('data-cart-action', 'notify');

    if (actionWrap) {
      actionWrap.classList.add('sold-out');
    }

  } else {
    // ✅ VERY IMPORTANT RESET
    btn.textContent = 'ADD TO CART';
    btn.disabled = false;

    btn.classList.remove('sold-out', 'notify-me');

    // ✅ RESET action
    btn.setAttribute('data-cart-action', 'add');

    if (actionWrap) {
      actionWrap.classList.remove('sold-out');
    }
  }
}

  function initButtons(scope = document) {
    scope.querySelectorAll('[data-cart-widget]').forEach(btn => {
      if (!btn.dataset.variantId) return;
      if (btn.dataset.available === undefined) return;
      syncSoldOutUI(btn);
    });
  }

  /* ==================================================
     CART OPEN (SAFE)
  ================================================== */
  function openCartDrawer() {
    // GoKwik / Ajax cart compatibility
    window.dispatchEvent(new Event('cart:open'));

    const trigger =
      document.querySelector('[data-cart-toggle]') ||
      document.querySelector('.cart-icon') ||
      document.querySelector('[href="/cart"]');

    trigger?.click();
  }

  /* ==================================================
     ADD TO CART HANDLER
  ================================================== */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-widget]');
    if (!btn) return;

    const action = btn.dataset.cartAction || 'add';
    const variantId = btn.dataset.variantId;
    const available = btn.dataset.available === 'true';

    //if (!variantId) return;

    if (!available) {
      openNotifyModal(btn);
      return;
    }

    e.preventDefault();

    /* OPEN CART ONLY */
    if (action === 'open') {
      openCartDrawer();
      return;
    }

    /* ADD TO CART */
    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.innerHTML = '<span class="btn-spinner"></span> Adding…';

    /* ==================================================
       OPTIONAL ADD-ONS (Gift Wrap / Gift Pouch / future
       categories, fully merchant-managed — see
       snippets/pdp-addons.liquid + assets/pdp-addons.js)

       Only ever engaged for the PDP hero button. Every
       other [data-cart-widget] button on the site
       (collection cards, bundle "Add+", quick-add without
       add-ons) falls through to the untouched single-item
       payload below, exactly as before.
    ================================================== */
    let selectedAddons = [];
    let addonGroupToken = null;
    if (btn.dataset.cartSource === 'pdp-hero' && typeof window.getSelectedAddons === 'function') {
      try {
        // Unique per Add to Cart click — strictly pairs this main-product
        // line to its add-on lines so Shopify never merges a second,
        // differently-configured Add to Cart of the same product/variant
        // into the same line and mixes up whose add-ons belong to whom.
        // Generated up front and only actually used below if add-ons end
        // up being selected.
        const candidateToken = 'ag_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
        selectedAddons = window.getSelectedAddons(btn, candidateToken) || [];
        if (selectedAddons.length) addonGroupToken = candidateToken;
      } catch (err) {
        console.error('[OneCart] getSelectedAddons failed', err);
        selectedAddons = [];
        addonGroupToken = null;
      }
    }

    const mainItem = { id: Number(variantId), quantity: 1 };
    if (selectedAddons.length && addonGroupToken) {
      // Hidden (leading "_") — never rendered in the cart drawer, per the
      // existing generic property-rendering convention in cart-drawer.liquid.
      mainItem.properties = { _addon_group: addonGroupToken };
    }

    const requestBody = selectedAddons.length
      ? {
          items: [
            mainItem,
            ...selectedAddons
          ]
        }
      : {
          id: Number(variantId),
          quantity: 1
        };

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
      });

      if (!res.ok) throw new Error('Add to cart failed');

      btn.innerHTML = 'ADDED ✓';
       closeQuickAddModalIfOpen(btn);

    } catch (err) {
      console.error('[OneCart]', err);
      btn.innerHTML = originalHTML;
    }

    setTimeout(() => {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.innerHTML = originalHTML;
    }, 900);
  });

  /* ==================================================
     PDP HERO – VARIANT SELECT DROPDOWN
  ================================================== */
  function updateHeroButtonsForVariant(variant) {
    if (!variant || !variant.id) return;

    document
      .querySelectorAll('[data-cart-widget][data-cart-source="pdp-hero"]')
      .forEach(btn => {
        btn.dataset.variantId = variant.id;
        btn.dataset.available = variant.available ? 'true' : 'false';
        syncSoldOutUI(btn);
      });
  }

  document.addEventListener('change', (e) => {
    const select = e.target.closest('select[name="id"]');
    if (!select) return;

    if (!window.Shopify || !Shopify.product) return;

    const variant = Shopify.product.variants.find(
      v => String(v.id) === String(select.value)
    );

    if (variant) {
      updateHeroButtonsForVariant(variant);
    }
  });

  /* ==================================================
     PDP CUSTOM VARIANT CARDS
  ================================================== */
  document.addEventListener('click', (e) => {
    const card = e.target.closest('.pdp-variant-card');
    if (!card) return;

    e.preventDefault();

    const variantId = card.dataset.variantId;
    const available = card.dataset.available === 'true';
    const image = card.dataset.image;

    if (!variantId) return;

    document.querySelectorAll('.pdp-variant-card')
      .forEach(c => c.classList.remove('active'));
    card.classList.add('active');

    document
      .querySelectorAll('[data-cart-widget][data-cart-source="pdp-hero"]')
      .forEach(btn => {
        btn.dataset.variantId = variantId;
        btn.dataset.available = available ? 'true' : 'false';
        syncSoldOutUI(btn);
      });

    if (image) {
      const mainImg =
        document.querySelector('#pdpMainImage') ||
        document.querySelector('.pdp-main-image img');

      if (mainImg) mainImg.src = image;
    }
  });

  /* ==================================================
     INIT
  ================================================== */
  document.addEventListener('DOMContentLoaded', () => {
    initButtons();
  });

 /* =====end cart =====*/
 
 function closeQuickAddModalIfOpen(triggerEl) {
  // Check if click happened inside a quick-add modal
  const quickAddModal = triggerEl.closest('quick-add-modal');
  if (!quickAddModal) return;

  // Find Shopify’s built-in close button
  const closeBtn = quickAddModal.querySelector('.quick-add-modal__toggle');
  if (closeBtn) {
    closeBtn.click();
  }
}
})();


/* ==================================================
   NOTIFY ME – FULL CONTROLLER (DB ONLY)
   ================================================== */
(function () {
  'use strict';

  const modal = document.getElementById('notifyModal');
  if (!modal) return;

  const emailInput = modal.querySelector('#notifyEmail');
  const submitBtn = modal.querySelector('.notify-submit');

  /* ==================================================
     OPEN MODAL
  ================================================== */
 window.openNotifyModal = function (btn) {
  modal.classList.add('active');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';

  modal.dataset.productId = btn.dataset.productId || '';
  modal.dataset.variantId = btn.dataset.variantId || '';
  modal.dataset.productName = btn.dataset.productName || '';
  modal.dataset.variantName = btn.dataset.variantName || '';

  if (emailInput) emailInput.value = '';
};

  /* ==================================================
     CLOSE MODAL
  ================================================== */
  function closeNotifyModal() {
    modal.classList.remove('active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ==================================================
     CLICK: OPEN NOTIFY MODAL
  ================================================== */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(
      '[data-cart-widget][data-cart-action="notify"]'
    );
    if (!btn) return;

    e.preventDefault();
    openNotifyModal(btn);
  });

  /* ==================================================
     CLICK: CLOSE MODAL
  ================================================== */
  document.addEventListener('click', (e) => {
    if (
      e.target.classList.contains('notify-close') ||
      e.target.classList.contains('notify-backdrop')
    ) {
      closeNotifyModal();
    }
  });

  /* ==================================================
     ESC KEY CLOSE
  ================================================== */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeNotifyModal();
    }
  });

  /* ==================================================
     SUBMIT – SAVE TO DATABASE ONLY
  ================================================== */
  emailInput?.addEventListener('input', () => {
  const errorBox = modal.querySelector('.notify-error');
  if (errorBox) errorBox.hidden = true;
});

submitBtn?.addEventListener('click', () => {
  const email = emailInput?.value.trim();
  const errorBox = modal.querySelector('.notify-error');
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Reset error first
  if (errorBox) errorBox.hidden = true;

  // Validation
  if (!email || !emailRegex.test(email)) {
    if (errorBox) {
      errorBox.textContent = 'Please enter a valid email address.';
      errorBox.hidden = false;
    }
    emailInput?.focus();
    return;
  }

  const payload = {
    product_id: modal.dataset.productId,
    variant_id: modal.dataset.variantId,
    product_name: modal.dataset.productName,
    variant_name: modal.dataset.variantName,
    product_url: window.location.href,
    email: email,
  };

  fetch('https://korneacloud.in/lillbud/store-notify-me.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
    .then((res) => {
      if (!res.ok) throw new Error('API failed');

      const body = modal.querySelector('.notify-body');
      const footer = modal.querySelector('.notify-footer');
      const success = modal.querySelector('.notify-success');

      if (body) body.style.display = 'none';
      if (footer) footer.style.display = 'none';
      if (success) success.hidden = false;

      setTimeout(() => {
        closeNotifyModal();

        // Reset modal for next open
        if (body) body.style.display = '';
        if (footer) footer.style.display = '';
        if (success) success.hidden = true;
        emailInput.value = '';
      }, 3000);
    })
    .catch(() => {
      if (errorBox) {
        errorBox.textContent = 'Something went wrong. Please try again.';
        errorBox.hidden = false;
      }
    });
});
emailInput?.addEventListener('input', () => {
  const errorBox = modal.querySelector('.notify-error');
  if (errorBox) errorBox.hidden = true;
});

})();



function initPDPHero(scope = document) {
  const hero = scope.querySelector('.pdp-main-image');
  const mainImg = scope.querySelector('#pdpMainImage');
  const videoEl = scope.querySelector('#pdpMainVideo');
  const thumbs = Array.from(scope.querySelectorAll('.thumb-img'));
  const prevBtn = scope.querySelector('.hero-left');
  const nextBtn = scope.querySelector('.hero-right');
  const thumbTrack = scope.querySelector('.thumb-track');
  const thumbPrev = scope.querySelector('.thumb-arrow.left');
  const thumbNext = scope.querySelector('.thumb-arrow.right');

  if (!hero || !mainImg || thumbs.length === 0) return;

  let index = thumbs.findIndex(t => t.classList.contains('active'));
  if (index < 0) index = 0;

  let isSliding = false; // 🔒 IMPORTANT LOCK

  /* ===============================
     THUMB SCROLL
  =============================== */
  if (thumbPrev && thumbNext && thumbTrack) {
    const SCROLL_AMOUNT = 120;

    thumbPrev.addEventListener('click', e => {
      e.preventDefault();
      thumbTrack.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' });
    });

    thumbNext.addEventListener('click', e => {
      e.preventDefault();
      thumbTrack.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' });
    });
  }

  function scrollThumbIntoView(thumb) {
    if (!thumbTrack) return;
    thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  /* ===============================
     CORE SLIDE LOGIC (FIXED)
  =============================== */
  function slideTo(newIndex) {
    if (isSliding) return; // 🚫 STOP overlap
    isSliding = true;

    if (newIndex < 0) newIndex = thumbs.length - 1;
    if (newIndex >= thumbs.length) newIndex = 0;

    index = newIndex;
    const thumb = thumbs[newIndex];
    const type = thumb.dataset.type || 'image';

    thumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    scrollThumbIntoView(thumb);

    if (type === 'video' && videoEl) {
      // ---- VIDEO ----
      mainImg.style.display = 'none';

      videoEl.pause();
      videoEl.currentTime = 0;
      videoEl.src = thumb.dataset.video;
      videoEl.style.display = 'block';

      const onReady = () => {
        videoEl.play();
        videoEl.removeEventListener('canplay', onReady);
        isSliding = false; // 🔓 unlock ONLY when ready
      };

      videoEl.addEventListener('canplay', onReady);
      videoEl.load();
    } else {
      // ---- IMAGE ----
      if (videoEl) {
        videoEl.pause();
        videoEl.style.display = 'none';
      }

      if (mainImg.src !== thumb.dataset.full) {
        mainImg.src = thumb.dataset.full;
      }

      mainImg.style.display = 'block';
      isSliding = false; // 🔓 immediate unlock for images
    }
  }

  /* ===============================
     CONTROLS
  =============================== */
  prevBtn?.addEventListener('click', () => slideTo(index - 1));
  nextBtn?.addEventListener('click', () => slideTo(index + 1));

  thumbs.forEach((t, i) => {
    t.addEventListener('click', () => {
      if (i !== index) slideTo(i);
    });
  });
}

function initMobileVariantScroll(scope = document) {
  if (!window.matchMedia('(max-width: 999px)').matches) return;

  const variantButtons = scope.querySelectorAll('.pdp-variant-card');
  const hero = scope.querySelector('.pdp-media');
  const track = scope.querySelector('.pdp-mobile-track');

  if (!variantButtons.length || !hero || !track) return;

  // ✅ SAFE scroll container detection
  let scrollContainer = window;

  if (scope instanceof Element) {
    scrollContainer =
      scope.closest('quick-add-modal') ||
      scope.closest('.modal__content') ||
      window;
  }

  const OFFSET = 100;

  variantButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const mediaId = btn.dataset.mediaId;
      if (!mediaId) return;

      /* ✅ SCROLL PAGE OR POPUP */
      setTimeout(() => {
        if (scrollContainer === window) {
          const y =
            hero.getBoundingClientRect().top +
            window.pageYOffset -
            OFFSET;

          window.scrollTo({ top: y, behavior: 'smooth' });
        } else {
          const top =
            hero.offsetTop - OFFSET;

          scrollContainer.scrollTo({
            top: Math.max(0, top),
            behavior: 'smooth'
          });
        }
      }, 80);

      /* ✅ SCROLL MOBILE CAROUSEL */
      const slide = track.querySelector(
        `.pdp-mobile-slide[data-media-id="${mediaId}"]`
      );

      if (slide) {
        setTimeout(() => {
          track.scrollTo({
            left: slide.offsetLeft,
            behavior: 'smooth'
          });
        }, 120);
      }
    });
  });
}

function initMobileThumbSync(scope = document) {
  if (!window.matchMedia('(max-width: 999px)').matches) return;

  const track = scope.querySelector('.pdp-mobile-track');
  if (!track || track.__thumbObserverInit) return; // 🔐 prevent duplicate init
  track.__thumbObserverInit = true;

  const slides = scope.querySelectorAll('.pdp-mobile-slide');
  const thumbs = scope.querySelectorAll('.thumb-img');
  if (!slides.length || !thumbs.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const index = Number(entry.target.dataset.index);
        if (isNaN(index)) return;

        thumbs.forEach(t => t.classList.remove('active'));
        const activeThumb = thumbs[index];
        if (!activeThumb) return;

        activeThumb.classList.add('active');
        activeThumb.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      });
    },
    { root: track, threshold: 0.6 }
  );

  slides.forEach(slide => observer.observe(slide));

  // Thumbs → hero
  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      slides[i]?.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    });
  });
}


function initVariantPriceAndCart(scope = document) {
  const priceWrap = scope.querySelector('.pdp-price');
  const priceNew = priceWrap?.querySelector('.price-new');
  const priceOld = priceWrap?.querySelector('.price-old');
  const priceOff = priceWrap?.querySelector('.price-off');
  const addToCart = scope.querySelector('.pdp-add-to-cart');

  if (!priceNew || !addToCart) return;

  const formatMoney = (cents) => {
    if (!cents) return '';
    return (
      '₹' +
      (cents / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  };

  scope.querySelectorAll('.pdp-variant-card').forEach((card) => {
    if (card.__priceInit) return; // 🔐 prevent double bind
    card.__priceInit = true;

    card.addEventListener('click', () => {
      /* ACTIVE STATE */
      scope
        .querySelectorAll('.pdp-variant-card')
        .forEach((v) => v.classList.remove('active'));
      card.classList.add('active');

      const price = parseInt(card.dataset.price, 10);
      const compare = parseInt(card.dataset.compare || 0, 10);
      const available = card.dataset.available === 'true';
      const variantId = card.dataset.variantId;

      /* PRICE */
      priceNew.textContent = formatMoney(price);

      if (compare && compare > price) {
        priceOld.textContent = formatMoney(compare);
        priceOff.textContent = formatMoney(compare - price) + ' OFF';
      } else {
        priceOld.textContent = '';
        priceOff.textContent = '';
      }
      /* ================================
        UPDATE OFFER CARD PRICES
      ================================ */

      scope.querySelectorAll('.offer-final-price').forEach((el) => {
        const discount = parseFloat(el.dataset.discount);
        if (isNaN(discount) || !price) return;

        const discounted = Math.round(price * (100 - discount) / 100);

        const oldPriceEl = el
          .closest('.offer-text')
          ?.querySelector('.offer-old-price');

        if (oldPriceEl) {
          oldPriceEl.textContent = formatMoney(price);
        }

        el.textContent = formatMoney(discounted);
      });



      /* ADD TO CART */
      addToCart.dataset.variantId = variantId;
         /* 🔧 UPDATE SHOPIFY VARIANT INPUT */
      const variantInput = scope.querySelector('input[name="id"]');

      if (variantInput) {
        variantInput.value = variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (!available) {
        addToCart.textContent = 'SOLD OUT';
        addToCart.disabled = true;
        addToCart.classList.add('sold-out');
      } else {
        addToCart.textContent = 'ADD TO CART';
        addToCart.disabled = false;
        addToCart.classList.remove('sold-out');
      }

      /* MOBILE → SCROLL HERO */
      if (window.matchMedia('(max-width: 999px)').matches) {
        const mediaId = card.dataset.mediaId;
        if (!mediaId) return;

        const slide = scope.querySelector(
          `.pdp-mobile-slide[data-media-id="${mediaId}"]`
        );

        slide?.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest',
        });
      }
    });
  });
}

function initAccordion(scope = document) {
  const headers = scope.querySelectorAll('.kh-header');
  if (!headers.length) return;

  const OFFSET = 90;

  headers.forEach(header => {
    if (header.__accordionInit) return; // 🔐 prevent double bind
    header.__accordionInit = true;

    header.addEventListener('click', () => {
      const item = header.closest('.kh-item');
      const content = item?.querySelector('.kh-content');
      if (!item || !content) return;

      const isOpen = item.classList.contains('active');

      /* CLOSE ALL (within scope only) */
      scope.querySelectorAll('.kh-item').forEach(i => {
        i.classList.remove('active');
        const c = i.querySelector('.kh-content');
        if (c) c.style.display = 'none';
      });

      /* OPEN CLICKED */
      if (!isOpen) {
        item.classList.add('active');
        content.style.display = 'block';

        setTimeout(() => {
          const y =
            header.getBoundingClientRect().top +
            window.pageYOffset -
            OFFSET;

          window.scrollTo({
            top: y,
            behavior: 'smooth'
          });
        }, 120);
      }
    });
  });
}